// extracted by mini-css-extract-plugin
export default {"wrapper":"O_tpD3vFMIyR1cvLaGql"};